module.exports = __webpack_public_path__ + "static/media/prometheus-logo.0a13073a.svg";